<ap-panel [bordered]="false" [title]="''" [class]="'ap-p-spacing-5 ap-mb-spacing-5 ' + panelClass">
  <ng-content></ng-content>

  @if (actions) {
    <div class="d-flex justify-content-end">
      @for (action of actions; track action) {
        <ap-button
          [btnType]="'text'"
          [icon]="action.icon!"
          (onClick)="onClick(action)"
          ap-tooltip
          [tooltipContent]="action.label!"
          [direction]="'top'"
          class="icon"
        ></ap-button>
      }
      @if (moreOptions) {
        <ap-menu-button
          [icon]="'vertical-more-outline'"
          [buttonData]="moreOptions"
          class="d-flex justify-content-end align-items-center icon"
          [compact]="true"
          >
          @for (item of moreOptions; track item) {
            <ap-dropdown-list-item [item]="item" (onSelectItem)="onSelectOption($event)" class="more-options">
              <span [class]="item.icon"></span>
            </ap-dropdown-list-item>
          }
        </ap-menu-button>
      }
    </div>
  }
</ap-panel>
